import { directSalesFlowPages, DirectSalesFlowSlug } from "../constants";
import { useFlowNavigation } from "../../signupFlow/hooks/useFlowNavigation";

// Keep utm_* params across direct sales pages so Northbeam can attribute the whole flow.
const DIRECT_SALES_CHAIN_OPTIONS = { keepTrackingParams: true };

export function useDirectSalesSignupFlowNavigation(slug: DirectSalesFlowSlug) {
  return useFlowNavigation(slug, directSalesFlowPages, DIRECT_SALES_CHAIN_OPTIONS);
}
